import { render, staticRenderFns } from "./private-inner.vue?vue&type=template&id=485e8ab3&scoped=true"
import script from "./private-inner.vue?vue&type=script&lang=js"
export * from "./private-inner.vue?vue&type=script&lang=js"
import style0 from "./private-inner.vue?vue&type=style&index=0&id=485e8ab3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485e8ab3",
  null
  
)

export default component.exports